    import React from 'react';
    import Accordion from 'react-bootstrap/Accordion';


const App1 = () => (
    <div className="DocumentLinksPage__content-container">
        <h2>Правила приема и нормативные документы</h2>
        <Accordion defaultActiveKey={['0']}>
            <Accordion.Item eventKey="0">
                <Accordion.Header>Документы приемной комиссии</Accordion.Header>
                <Accordion.Body>
                    <ul>
                        <li>
                            <a href="https://www.art-gzhel.ru/abitur/spo/doc/pravila_priema_spo_24_02_2025.pdf"
                               target="_blank" rel="noopener noreferrer">
                                Правила приема
                            </a>
                        </li>
                        <li>
                            <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/pk.pdf" target="_blank"
                               rel="noopener noreferrer">
                                Положение о приемной комиссии
                            </a>
                        </li>
                        <li>
                            <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/ek.pdf" target="_blank"
                               rel="noopener noreferrer">
                                Положение об экзаменационной комиссии
                            </a>
                        </li>
                        <li>
                            <a href="https://www.art-gzhel.ru/abitur/bachelor/doc/ak.pdf" target="_blank"
                               rel="noopener noreferrer">
                                Положение об апелляционной комиссии
                            </a>
                        </li>
                        <li>
                            <a href="/pdf/apellation_rules.pdf" target="_blank"
                               rel="noopener noreferrer">
                                Правила подачи и рассмотрения апелляции
                            </a>
                        </li>
                        <li>
                            <a href="/pdf/individual_achievement_of_SPO.pdf" target="_blank"
                               rel="noopener noreferrer">
                                Порядок учета индивидуальных достижений
                            </a>
                        </li>
                    </ul>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
                <Accordion.Header>Учредительные и организационно-правовые документы</Accordion.Header>
                <Accordion.Body>
                    <ul>
                        <li>
                        <a href="https://www.art-gzhel.ru/sveden/document/doc/oo/ustav_21_11_2022.pdf"
                               target="_blank" rel="noopener noreferrer">
                                Копия устава университета
                            </a>
                        </li>
                        <li>
                            <a href="https://www.art-gzhel.ru/sveden/doc/vipiska_svidetelstvo.pdf"
                               target="_blank" rel="noopener noreferrer">
                                Выписка из реестра организаций, осуществляющих образовательную деятельность по имеющим государственную аккредитацию образовательным программам
                            </a>
                        </li>
                        <li>
                            <a href="https://www.art-gzhel.ru/sveden/doc/licen_16_06_2025.pdf"
                               target="_blank" rel="noopener noreferrer">
                                Выписка из реестра лицензий
                            </a>
                        </li>
                    </ul>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
                <Accordion.Header>Нормативные документы</Accordion.Header>
                <Accordion.Body>
                    <ul>
                        <li>
                            <a href="/pdf/Law_29122012_N273FZ_Education_RF_2024.pdf" target="_blank"
                               rel="noopener noreferrer">
                                Федеральный закон от 29.12.2012 № 273-ФЗ «Об образовании в Российской Федерации»
                            </a>
                        </li>
                        <li>
                            <a href="/pdf/Federal_Law_27072006_N152FZ_Personal_Data.pdf" target="_blank"
                               rel="noopener noreferrer">
                                Федеральный закон от 27.07.2006 № 152-ФЗ «О персональных данных»
                            </a>
                        </li>
                        <li>
                            <a href="/pdf/Federal_Law_25072002_N115-FZ_Status_Foreign_Citizens_RF.pdf" target="_blank"
                               rel="noopener noreferrer">
                                Федеральный закон от 25.07.2002 N 115-ФЗ «О правовом положении иностранных граждан в
                                Российской Федерации»
                            </a>
                        </li>
                        <li>
                            <a href="/pdf/Federal_Law_24051999_N99-FZ_State_Policy_Compatriots_Abroad.pdf"
                               target="_blank" rel="noopener noreferrer">
                                Федеральный закон от 24.05.1999 N 99-ФЗ «О государственной политике Российской Федерации
                                в отношении соотечественников за рубежом»
                            </a>
                        </li>
                        <li>
                            <a href="/pdf/Federal_Law_21121996_N159-FZ_Social_Support_Orphans_Vulnerable_Children.pdf"
                               target="_blank" rel="noopener noreferrer">
                                Федеральный закон от 21.12.1996 N 159-ФЗ «О дополнительных гарантиях по социальной
                                поддержке детей-сирот и детей, оставшихся без попечения родителей»
                            </a>
                        </li>
                    </ul>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    </div>
);

export default App1;
